import PropTypes from "prop-types";
import React from "react";

export default function TextBlock(props) {
    if(props.field && props.field.length > 0){
        let additionalStyles = props.styleClass ? props.styleClass : "";            
        return (
            <span className={`fieldText ${additionalStyles}`}>
                {props.field} 
            </span>
        );
    }
    else {
        return (
            <span className={`fieldText placeholder`}>
                {props.placeholder}
            </span>
        );            
    }
}

TextBlock.propTypes = {
    field: PropTypes.string,
    placeholder: PropTypes.string,
    styleClass: PropTypes.string
};

